var map = {
	"./labmem_text_btntest_en.png": "c802",
	"./labmem_text_btntest_jp.png": "94dd",
	"./labmem_text_btntest_kr.png": "543e",
	"./labmem_text_btntest_sc.png": "9be3",
	"./labmem_text_btntest_tc.png": "1e1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4ec";